var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaceholder = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 28",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#667085",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M22.667 26c0-1.86 0-2.791-.23-3.548a5.33 5.33 0 0 0-3.556-3.556c-.757-.23-1.687-.23-3.548-.23H8.667c-1.861 0-2.792 0-3.549.23a5.33 5.33 0 0 0-3.555 3.556c-.23.757-.23 1.687-.23 3.548M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/placeholder.d2a33d285a51e61d05dea227052d359b.svg";